export default function loadScript(url) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}
